import { type ContactRequestV1 } from '@redteclab/api/clients/bully'

import { type ContactFormState } from './contactFormMakeContactFormState'

export const serializeModelToRequestPayload = (
  model: ContactFormState['model'],
): ContactRequestV1 => {
  return {
    email: model.email,
    fcSolution: model.fcSolution,
    firstName: model.firstName,
    lastName: model.lastName,
    message: model.message,
    orderId: model.orderId,
    productCode: model.productCode,
    subject: model.subject,
  }
}
